export default __webpack_public_path__ + "mini-icon-android-14@2x.png";